export interface StyleTemplateModel {
  id: number;
  title: string;
}

export enum ColorizerModalTypes {
  Create = 'create',
  Update = 'update',
  Load = 'load',
  Save = 'save'
}
